export { default as CopyButton } from './CopyButton.vue';
